import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {IPickupSearch, IShipmentSearch, PickupReducerType} from "./Types";
import Pickup from "../../Models/Pickup";
import Shipment from "../../Models/Shipment";
import Unit from "../../Models/Unit";
import NewPickup from "../../Models/NewPickup";


const initialState: PickupReducerType = {
  pickups: [],
  pPending: [],
  pScheduled: [],
  pPickups: [],
  pCanceled: [],
  shipmentsByPickup: [],
  shipments: [],
  unitsByShipment: [],
}

const PickupSlice = createSlice({
  name: "Pickup",
  initialState,
  reducers: {
    getPickups(state: PickupReducerType, {payload}: PayloadAction<IPickupSearch|undefined>) {},
    setPickups(state: PickupReducerType, {payload}: PayloadAction<Pickup[]>) {
      state.pickups = payload;
    },
    setShipments(state: PickupReducerType, {payload}: PayloadAction<Shipment[]>) {
      state.shipments = payload;
    },
    setPickupsPending(state: PickupReducerType, {payload}: PayloadAction<Pickup[]>) {
      state.pPending = payload;
    },
    setPickupsScheduled(state: PickupReducerType, {payload}: PayloadAction<Pickup[]>) {
      state.pScheduled = payload;
    },
    setPickupsPickup(state: PickupReducerType, {payload}: PayloadAction<Pickup[]>) {
      state.pPickups = payload;
    },
    setPickupsCancel(state: PickupReducerType, {payload}: PayloadAction<Pickup[]>) {
      state.pCanceled = payload;
    },
    savePickup(state: PickupReducerType, {payload}: PayloadAction<NewPickup>) {},
    updatePickup(state: PickupReducerType, {payload}: PayloadAction<Pickup>) {},
    cancelPickup(state:PickupReducerType,{payload}:PayloadAction<Pickup>){},
    getShipmentsByPickup(state: PickupReducerType, {payload}: PayloadAction<IShipmentSearch>) {},
    setShipmentsByPickup(state: PickupReducerType, {payload}: PayloadAction<Shipment[]>) {
      state.shipmentsByPickup = payload;
    },
    deleteShipment(state: PickupReducerType, {payload}: PayloadAction<Shipment>){},
    getUnitsByShipment(state: PickupReducerType, {payload}: PayloadAction<Shipment>){},
    setUnitsByShipment(state: PickupReducerType, {payload}: PayloadAction<Unit[]>){
      state.unitsByShipment = payload;
    },
  }
})

export const PickupActions = PickupSlice.actions;
export default PickupSlice.reducer;
